import React from 'react'
import { useConfiguration } from '../contexts/ConfigurationContext'
import { MapPin, Globe } from 'lucide-react'

function LocationsDisplay() {
  const { state } = useConfiguration()

  if (!state.selectedProvider) {
    return null
  }

  const { locations } = state.selectedProvider

  const getLocationFlag = (country) => {
    const flags = {
      'Germany': '🇩🇪',
      'Ireland': '🇮🇪', 
      'UK': '🇬🇧',
      'France': '🇫🇷',
      'USA': '🇺🇸',
      'Belgium': '🇧🇪',
      'Netherlands': '🇳🇱',
      'Poland': '🇵🇱'
    }
    return flags[country] || '🌍'
  }

  return (
    <div className="card">
      <div className="flex items-center space-x-2 mb-4">
        <MapPin className="h-4 w-4 text-primary-600" />
        <h3 className="text-base font-semibold text-gray-900">
          Data Center Locations
        </h3>
      </div>

      <div className="space-y-3">
        <div className="flex items-center space-x-2 text-sm text-gray-600 mb-4">
          <Globe className="h-4 w-4" />
          <span>{locations.length} locations available with {state.selectedProvider.shortName}</span>
        </div>

        <div className="grid grid-cols-1 gap-3">
          {locations.map((location, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <div className="flex items-center space-x-3">
                <span className="text-lg">{getLocationFlag(location.country)}</span>
                <div>
                  <div className="font-medium text-gray-900">
                    {location.city}
                  </div>
                  <div className="text-sm text-gray-500">
                    {location.country} • {location.region}
                  </div>
                </div>
              </div>
              
              <div className="text-right">
                <div className="text-xs text-gray-500">
                  {location.lat.toFixed(2)}°, {location.lon.toFixed(2)}°
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Compliance Note */}
        <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
          <div className="text-sm text-green-800">
            <p className="font-medium mb-1">✓ Compliance Status</p>
            <div className="space-y-1 text-xs">
              {state.selectedProvider.gdprCompliant && (
                <p>• GDPR compliant with EU data protection standards</p>
              )}
              {state.selectedProvider.nonUsCloudAct && (
                <p>• Non-US provider ensuring data sovereignty</p>
              )}
              <p>• Certifications: {state.selectedProvider.certifications.join(', ')}</p>
            </div>
          </div>
        </div>

        {/* Location Summary */}
        <div className="text-xs text-gray-500 text-center pt-2 border-t">
          All locations feature redundant infrastructure and 99.9%+ uptime SLA
        </div>
      </div>
    </div>
  )
}

export default LocationsDisplay 